var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvoid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0957 5.5571L10.4429 4.9043L8.00005 7.34725L5.55722 4.9043L4.90442 5.5571L7.34737 7.99993L5.21211 10.1351L5.86491 10.7879L8.00005 8.65261L10.1352 10.7879L10.788 10.1351L8.65273 7.99993L11.0957 5.5571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvoid);
export default __webpack_public_path__ + "static/media/avoid.2c8b07b23a48376576a1e47cfd070b66.svg";
export { ForwardRef as ReactComponent };